import { EventEmitter, Injectable, Output } from '@angular/core'
import { Router } from '@angular/router'

@Injectable({
  providedIn: 'root',
})
export class SidebarService {
  hideSidebar: boolean = false

  //hideRoutes: string[] = ['/main/organizations',]

  constructor(private router: Router) {
    if (this.router.url.includes('/main/organizations')) {
      this.hideSidebar = true
    } else {
      this.hideSidebar = false
    }
  }

  toggleSidebar(): void {
    this.hideSidebar = !this.hideSidebar
  }

  disableSidebar(): void {
    this.hideSidebar = true
  }

  enableSidebar(): void {
    this.hideSidebar = false
  }
}
